var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "34.95px",
    height: "34.95px",
    viewBox: "0 0 34.95 34.95",
    enableBackground: "new 0 0 34.95 34.95",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    transform: "translate(-22.361 -26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_10",
    transform: "translate(22.361 26)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 17.475,
    cy: 17.475,
    r: 17.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 17.475,
    cy: 17.475,
    r: 16.975
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    fill: "#FFBF00",
    d: "M40.152,35.153c1.989,0,3.6,1.612,3.6,3.6s-1.611,3.6-3.6,3.6c-1.988,0-3.6-1.612-3.6-3.6 l0,0C36.552,36.765,38.164,35.153,40.152,35.153 M40.152,33.713c-2.784-0.001-5.042,2.254-5.044,5.038 c-0.002,2.784,2.254,5.042,5.038,5.044c2.784,0.002,5.042-2.254,5.043-5.038c0-0.001,0-0.002,0-0.003 C45.191,35.971,42.936,33.714,40.152,33.713z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    fill: "#FFBF00",
    d: "M47.35,53.877h-1.441v-3.601c0-1.988-1.611-3.601-3.6-3.601h-4.318 c-1.988,0-3.6,1.612-3.6,3.601v3.601h-1.44v-3.601c-0.001-2.783,2.254-5.04,5.038-5.042c0.001,0,0.002,0,0.003,0h4.319 c2.783,0,5.039,2.258,5.038,5.041L47.35,53.877z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.e712ceec547d7852466f3d3add0c09ac.svg";
export { ForwardRef as ReactComponent };